import styled from "styled-components";

export const Container = styled.div`
  &.ant-modal {
    padding-bottom: 0px !important;
  }
  .ant-row,
  .ant-row-flex {
    margin-bottom: 0.5rem;
  }
  .ant-row:nth-of-type(2),
  .ant-row-flex:nth-of-type(2) {
    margin-bottom: 18px;
  }

  label {
    color: #9074bf;
    font-family: "Asap", sans-serif;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    &:first-child {
      margin-top: 5px;
    }
    &.error {
      color: #d44c4c;
    }
  }
  .ant-select {
    width: 100%;
  }

  .body {
    margin-bottom: 16px;
    .ant-row-flex {
      margin-top: 8px;
    }
  }
`;
